import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import { WordPhraseSearchModel } from "@/models/word-phrase-search-model";

class WordPhraseSearchServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getWordPharseSearchList(params?: any): Promise<WordPhraseSearchModel[]> {
		return this.request.get(this.url("getwordphrasesearchlist"), params);
	}
}

export const WordPhraseSearchService = new WordPhraseSearchServiceClass();
